export const getObjectFromEntries = (entries) => entries.reduce((obj, [key, value]) => {
    return Object.assign(Object.assign({}, obj), { [key]: value });
}, {});
